import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "@/components/common/Rich";

const Row = ({ label, text }) => (
  <div className="border-t border-line pt-4">
    <dt className="font-mono text-[12px] uppercase tracking-[0.18em] text-accent">{label}</dt>
    <dd className="mt-2 text-[15px] leading-relaxed text-ink/90">
      <Rich text={text} />
    </dd>
  </div>
);

// Licensing example: Challenge / What SPC did / Outcome.
export const ExampleCards = ({ items = [] }) => (
  <div className="grid gap-6 md:grid-cols-2" data-testid="licensing-examples">
    {items.map((e, i) => (
      <Reveal key={e.id} delay={i * 0.1} as="article" className="group flex flex-col overflow-hidden border border-line bg-surface" data-testid={`example-card-${e.id}`}>
        <div className="relative h-52 overflow-hidden">
          <img src={e.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
          <span className="absolute left-4 top-4 rounded-none bg-paper/90 px-3 py-1 font-mono text-[12px] uppercase tracking-[0.14em] text-ink backdrop-blur">
            {e.area}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-6 sm:p-8">
          <h3 className="font-display font-semibold tracking-[-0.03em] text-[1.9rem] leading-tight text-ink">{e.title}</h3>
          <dl className="mt-6 space-y-5">
            <Row label="Challenge" text={e.challenge} />
            <Row label="What SPC did" text={e.did} />
            <Row label="Outcome" text={e.outcome} />
          </dl>
          {e.to && (
            <Link to={e.to} className="mt-6 inline-flex items-center gap-1 text-[15px] font-medium text-accent underline-offset-4 hover:underline" data-testid={`example-link-${e.id}`}>
              View product <ArrowUpRight className="h-4 w-4" />
            </Link>
          )}
        </div>
      </Reveal>
    ))}
  </div>
);
